var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.12 39.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANO"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.82,35.6c-.42.02-.85-.1-1.2-.38-.76-.6-.88-1.7-.27-2.45L29.99,9.98c.45-.55.65-1.23.58-1.93-.08-.7-.42-1.33-.98-1.77l-2.8-2.22c-.55-.44-1.26-.64-1.96-.57-.71.08-1.35.42-1.79.96L4.4,27.26c-.62.75-1.73.87-2.49.27-.76-.6-.88-1.7-.27-2.45L20.28,2.28C21.32,1.01,22.8.21,24.45.03c1.66-.17,3.27.29,4.56,1.32l2.8,2.22c1.29,1.02,2.1,2.48,2.28,4.11.18,1.62-.3,3.22-1.34,4.49l-18.64,22.79c-.33.4-.8.62-1.28.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.29,16.69c-.42.02-.85-.1-1.2-.38l-9.71-7.7c-.76-.6-.88-1.7-.27-2.45.61-.75,1.73-.87,2.49-.27l9.71,7.7c.76.6.88,1.7.27,2.45-.33.4-.8.62-1.28.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.87,39.22c-.43.02-.86-.11-1.2-.38-.47-.37-.71-.96-.65-1.55l1.25-11.32c.11-.96.99-1.65,1.95-1.54.97.1,1.67.96,1.57,1.92l-.95,8.61,8.34-2.75c.93-.3,1.93.19,2.24,1.1.31.91-.19,1.9-1.12,2.21l-10.96,3.62c-.15.05-.31.08-.47.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/EDITAR.c405bfba80e4df00100e04e30cc8b579.svg";
export { ForwardRef as ReactComponent };